(function (w) {
	'use strict';

	/**
	 * @ngdoc directive
	 * @name mx.components:mxTextBox
	 * @module mx.components
	 * @restrict 'E'
	 * @description
	 * The mx-text-box control is used to create a text box where the user can input text.
	 *
	 * The example below demonstrates some of the attributes you may use with the TextBox control:
	 * @param {string} name@ - The name property sets or returns the value of the name attribute of a mxTextBox.
	 * @param {string} label@ - Defines label displayed on the form
	 * @param {boolean} required= - The required property sets or returns whether a mxTextBox must be filled out before submitting a form.
	 * @param {boolean} disabled= - The disabled property sets or returns whether a mxTextBox should be disabled, or not.
	 * @param {boolean} readOnly= - The readOnly property sets or returns whether the contents of a mxTextBox should be read-only.
	 * @param {boolean} mask= - The mask property sets or returns whether the contents of a mxTextBox should be maskable by concrete mask type.
	 * @param {string} maskFormat= - The maskFormat property sets or returns whether the contents of a mxTextBox should have mask pattern.
	 * @param {object} model=ngModel - directive binds element to the object in the model.
	 * @param {string} type="email" - <a href="https://docs.angularjs.org/api/ng/input/input[email]">E-mail directive</a>
	 * @param {string} ngPattern - <a href="https://docs.angularjs.org/api/ng/directive/ngPattern">ngPattern</a>
	 *
	 * @usage <mx-text-box ng-model="vm.inputData" data-label="mixed" data-read-only="true" data-disabled="true" data-required="true" data-name="readOnly" ng-pattern="regex"></mx-text-box>
	 */

	angular.module('mx.components').directive('mxTextBox', function mxTextBoxDirective() {
		const directive = new mx.components.FormControlBase(MxTextBoxCtrl, '');
		directive.template = mxTemplate;

		angular.extend(directive.bindToController, {
			type: '@',
			pattern: '<?',
		});

		return directive;
	});

	MxTextBoxCtrl.$inject = ['$element', '$timeout'];

	function MxTextBoxCtrl($element, $timeout) {
		var vm = this;

		vm.$onInit = function () {
			mx.components.FormControlControllerBase.call(vm, $timeout);
			vm.trackInternal = vm.type !== 'text' && vm.type !== 'password';
		};

		vm.$postLink = function () {
			var input = $element.find('input');
			if (input) {
				input.on('blur', function () {
					$element.blur();
					vm.showingHints(false);
				});
				input.on('focus', function () {
					$element.triggerHandler('focus');
					vm.showingHints(true);
				});
			}
		};

		return vm;
	}

	function mxTemplate(elem, attr) {
		var useDebounce = attr.debounce !== 'false';
		var type = attr.type || 'text';
		return (
			'<md-input-container md-is-error="vm.controlNgModel.mxInvalid">' +
			'<label ng-readonly="::vm._readOnly"><span ng-bind-html="vm.label"></span></label>' +
			'<input name="{{::vm.internalName}}" type="' +
			type +
			'" ' +
			getMaskTemplateByType(attr) +
			'ng-model="vm.model" ' +
			'mx-update-on-enter ' +
			'ng-model-options="{' +
			"updateOn: 'blur " +
			(useDebounce ? 'default' : '') +
			"', " +
			'debounce: {blur:0 ' +
			(useDebounce ? ',default:' + (attr.debounce || 1000) : '') +
			'}, ' +
			'allowInvalid: true' +
			'}" ' +
			'ng-disabled="vm._disabled" ' +
			'ng-readonly="vm._readOnly" ' +
			'aria-describedby="{{::vm.msgElemId}}" ' +
			'ng-pattern="vm.pattern" />' +
			'<div class="mx-input-hint" ng-show="vm._showHints" title="{{::vm.hintPlainText}}">{{::vm.hintPlainText}}</div>' +
			'<mx-control-errors track-internal="{{::vm.trackInternal}}" ng-show="!vm._showHints" options="{validationStatus:vm.validationStatus}" msg-elem-id="{{::vm.msgElemId}}">' +
			'</mx-control-errors>' +
			'</md-input-container>'
		);
	}

	function getMaskTemplateByType(attr) {
		var maskTemplate = attr.mxMask !== null && attr.mxMask !== undefined ? 'mx-mask="' + attr.mxMask + '"' : '';
		if (maskTemplate !== '') {
			switch (attr.mxMask) {
				case 'interval':
					if (attr.mxMaskFormat) {
						maskTemplate += ' mx-mask-format="' + attr.mxMaskFormat + '" ';
					}

					break;
			}
		}

		return maskTemplate;
	}

	w.mx = w.mx || {};
	w.mx.components = w.mx.components || {};
	w.mx.components.Forms = w.mx.components.Forms || {};
})(window);
